<template>
  <div id="app">
    <navigation class="top-plan" />
    <vue-page-transition name="overlay-left-full">
      <router-view class="router-plan" />
    </vue-page-transition>
    <socialblock class="social-plan" />
    <footerblock class="footer-plan" />
  </div>
</template>

<script>
import navigation from '@/components/navigation'
import footerblock from '@/components/footerblock'
import socialblock from '@/components/social'

export default {
  name: 'App',
  components: {
    navigation,
    footerblock,
    socialblock
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.overlay-left,
.overlay-right,
.overlay-top,
.overlay-bottom {
  background: var(--primary) !important;
  background-image: url('/static/assets/transition-bg.jpg') !important;
  background-size:cover;
  opacity:1
}
</style>



// WEBPACK FOOTER //
// src/App.vue